import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles/other.css';
import Axios from 'axios';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import assets
import icon_add_white from '../assets/icon_add_white.png';

// import components
import EditButtonDropdown from '../components/EditButtonDropdown.js';
import ExpandButton from '../components/ExpandButton.js';

class ProjectApplicationsTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            noRecordsFound: false,
            listOfUsers: ([{id:1, label: "John Smith"},{id:1, label: "Peter Novak"},{id:1, label: "Somebody Else"}]),
            listOfCountry: ([{id:1, label: "Czech republic"},{id:1, label: "United States"},{id:1, label: "Ukraine"}]),
            listOfRoles: ([{id:1, label: "CTL approvement"},{id:1, label: "Reasonability Pre-check"},{id:1, label: "GT approvement"}]),
            selectedCountry: 0,
            selectedRole: 0,
            selectedUser: 0,
        }
    }

    componentDidMount(){
    }

    onDelete = (id) => {
        alert("onDelete action!");
    }

    onApplicationClick = (id) => {
        //code
        alert("on Application Click!");
    }

    openCloseTile = () => {
        if(this.props.isOpen){
            this.props.setActualOpenedTile("");
        }
        else {
            this.props.setActualOpenedTile("conversations");
        }
    }

    render() {
        return (
            <div className="universalLeftTileWithTable" style={{marginBottom: 20}}>

                <div className="horizontalStack">

                    <ExpandButton isOpen={this.props.isOpen} style={{marginTop: 5}} onClick={this.openCloseTile} />

                    <div style={{width: "20px"}}></div>

                    <div className="verticalStack flex" style={{display: "table", tableLayout: "fixed", width: "100%"}}>
                        <span className="fontPoppinsSemiBold15">{"Applications"}</span>
                        <span className={this.props.isOpen ? "fontPoppinsRegular13Gray oneLineThreeDotsTextDeactivated" : "fontPoppinsRegular13Gray oneLineThreeDotsText"}>{"Use this tool for taking notes on conversations and notifying others about follow up needs. Click on the button on the right to start. Add the people involved, the date, and choose the topic of conversation. Below are all the conversations that include this contact."}</span>
                    </div>

                    <div style={{width: "20px"}}></div>

                    <div className="circleButtonContainer circleButtonContainerOrange clickable" style={{marginTop: 5}} onClick={() => this.openModal("AddConversation")}>
                        <img className="circleButton" style={{width: "16px", height: "16px", opacity: "0.9"}} src={icon_add_white}/>
                    </div>

                </div>

                <div className="horizontalStackCenter" style={{display: this.props.isOpen ? "" : "none"}}>

                        <table className="universalTableInLeftTile" style={{marginTop: 10}}>
                            <tr>
                                <td className="universalTableInLeftTileHeader" nowrap="nowrap">Created by</td>
                                <td className="universalTableInLeftTileHeader" nowrap="nowrap">Status</td>
                                <td className="universalTableInLeftTileHeader" nowrap="nowrap">Requested Amount</td>
                                <td className="universalTableInLeftTileHeader" nowrap="nowrap">Edit</td>
                            </tr>

                            {this.props.applicationsData.map(function (item) {
                                return (
                                    <tr key={item.id} onClick={() => this.onApplicationClick(item.id)}>
                                        <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap">{item.user}</td>
                                        <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap">{item.status}</td>
                                        <td className="universalTableInLeftTileGeneralDiv responsiveTableDiv" nowrap="nowrap">{item.amount}</td>
                                        <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap">
                                            <EditButtonDropdown itemId={item.id} onEdit={null} onDelete={this.onDelete} text={"Are you sure want to delete this application?"}/>
                                        </td>
                                    </tr>
                                )
                            }.bind(this))}

                            {/* if array empty but not because I received nothing from API then show row with text "Loading..." */}
                            {this.props.applicationsData.length == 0 && !this.state.noRecordsFound ? <tr> <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap" colspan="4" style={{textAlign: "center", padding: 10}}>{"Loading..."}</td> </tr> : null}

                            {/* if array empty because I did not receive any records, then show row with text like "No Records Found" */}
                            {this.props.applicationsData.length == 0 && this.state.noRecordsFound ? <tr> <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap" colspan="4" style={{textAlign: "center", padding: 10}}>{"No Roles Yet"}</td> </tr> : null}

                        </table>

                </div>

            </div>
        );
    }
}

export default ProjectApplicationsTile;
